import React, { Component } from 'react';
import $ from 'jquery'
import { Link } from 'react-router-dom';
import * as Common from '../CommonControlls/CommonJs';
import AppLogo_white from '../../images/AppLogo_white.jpeg'
import LoginForm_sideImage from '../../images/LoginForm_sideImage.jpg'
import { connect } from 'react-redux'

import AppLogo_Background from '../../images/AppLogo_Background.png'
import Login_Backgroud from '../../images/Login_Backgroud.png'


const mapStateToProps = (store)=>{
    return store
  }
  
const mapDispatchToProps = (dispatch)=>{
    return{
      ShowAlert : (Settings)=> {dispatch({type:"UpdateAlert",payload:Settings})},
      ShowLoader:(Isloading)=> {dispatch({type:"UpdateLoader",payload:Isloading})},
    }
}

class forgotpassword extends Component {
constructor(props) {
    super(props);
    this.state = {
        isEmail:false,
        verificationCode:null,
        isExpired:true,
        UserId:0,
    };
}
    render(){
 
        return(
<div>

<div class="login_Container">

    <div class="side_Image">
        <img src={AppLogo_Background} style={{height:"65px"}}/>
        <p>Welcome Back to Riders For Health</p>
        <img src={Login_Backgroud} style={{maxHeight:"410.5px",maxWidth:"594.8px"}}/>
    </div>
    
    <form id="Form_1stStep" class="login_form" onSubmit={this.ValidateUserForm} novalidate >

        <div class="Form_PageTitle">Restore Password</div>
        
        <div class="loginform_Content" style={{marginTop:"0px"}}>

            <p>Remember password? <Link to="/Login" class="basicLink_Tag"> Sign In</Link></p>

            <div style={{marginTop:"30px"}}>

                <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div style={{display:"flex",justifyContent:"center"}}>
                        <div class={ this.state.isEmail?"SelectionCard" : "SelectionCard active" } onClick={((e)=>{this.setState({isEmail:false})})}>
                            <i class="fa fa-phone" aria-hidden="true"></i>
                            <span>Phone</span>
                        </div>
                        <div class={ !(this.state.isEmail)?"SelectionCard" : "SelectionCard active" } onClick={((e)=>{this.setState({isEmail:true})})}>
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                            <span>Email</span>
                        </div>  
                    </div>
                </div>

                <p style={{fontSize:"15px",marginTop:"20px"}}>Please enter you {this.state.isEmail? "email" :"phone"} to Recover Password</p>

            </div>

        </div>

        <div class="loginform_form row d-flex justify-content-center">

            <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px",marginBottom:"30px"}} hidden={!(this.state.isEmail)}>
                <label for=""><span style={{color:"red"}}>* </span>Email</label>
                <input autocomplete="off" type="email" class="form-control" placeholder="Enter your email" id="RecoverPassword_Email" autoFocus required={this.state.isEmail}/>
            </div>

            <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px",marginBottom:"30px"}} hidden={this.state.isEmail}>
                <label for=""><span style={{color:"red"}}>* </span>Phone</label>
                <input autocomplete="off" pattern="[0][0-9]{10}" type="text" class="form-control" placeholder="Enter your phone - 03123456789" id="RecoverPassword_Phone" required={!(this.state.isEmail)}/>
            </div>

            <div class="loginform_footer formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px"}}>
                <button type="submit" class="btn LogInForm_btn">RECOVER PASSWORD</button>
            </div>

        </div>

    </form>

    <form id="Form_2ndStep" class="login_form" onSubmit={this.VerifyCode} novalidate style={{display:"none"}}>

        <div class="Form_PageTitle">Restore Password</div>

        <div class="loginform_Content" style={{marginTop:"0px",padding:"0px 135px"}}>
            <p>Remember password? <Link to="/Login" class="basicLink_Tag"> Sign In</Link></p>
            <p style={{marginBottom:"10px",fontSize:"15px"}}>A verification code has been sent to your phone number, please enter sent code to create account.</p>
        </div>

        <div class="loginform_form row d-flex justify-content-center">

            <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px"}}>
                <label for=""><span style={{color:"red"}}>* </span>Enter Code</label>
                <input autocomplete="off" type="text" class="form-control" placeholder="Enter verification code" id="RecoverPassword_VerficationCode" required/>
            </div>

            <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px"}}>
                <div hidden={this.state.isExpired}>Resend ( <span class="countdown"></span> ) </div>
                <div style={{position:"absolute"}} hidden={!(this.state.isExpired)}><a onClick={this.SendCode} style={{cursor:"pointer"}} class="basicLink_Tag">Resend</a> </div>
            </div>

            <div class="loginform_footer formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px",marginTop:"15px"}}>
                <button type="submit" class="btn LogInForm_btn">VERIFY</button>
            </div>

        </div>

    </form>

    <form id="Form_3rdStep" class="login_form" onSubmit={this.ResetPassword} novalidate style={{display:"none"}}>

        <div class="Form_PageTitle">Restore Password</div>

        <div class="loginform_Content" style={{marginTop:"0px",padding:"0px 135px"}}>
            <p>Remember password? <Link to="/Login" class="basicLink_Tag"> Sign In</Link></p>
            <p style={{marginBottom:"10px",fontSize:"15px"}}>Please enter new password to reset.</p>
        </div>

        <div class="loginform_form row d-flex justify-content-center">

            <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px",marginBottom:"30px"}}>
                <label for=""><span style={{color:"red"}}>* </span>New Password</label>
                <input autocomplete="off" type="password" class="form-control" placeholder="Enter your new password" id="ResetPassword_Password" required/>
            </div>

            <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px",marginBottom:"20px"}}>
                <label for=""><span style={{color:"red"}}>* </span>Confirm New Password</label>
                <input autocomplete="off" type="password" class="form-control" placeholder="Confirm your new password" id="ResetPassword_ConfirmPassword" required/>
            </div>

            <div class="loginform_footer formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px",marginTop:"15px"}}>
                <button type="submit" class="btn LogInForm_btn">SUBMIT</button>
            </div>

        </div>

    </form>

</div>


</div>
)}

ValidateUserForm=(e)=>{
    e.preventDefault()
    this.SendCode()
}
SendCode=()=>{
    this.props.ShowLoader({Isloading:true})
    var Parameters={
        User: this.state.isEmail? $("#RecoverPassword_Email").val() : $("#RecoverPassword_Phone").val(),
        IsEmail:this.state.isEmail
    }
    Common.Ajax("","Get",false,Common.APILinks.RecoverPassword,Parameters,(resp)=>{
        this.props.ShowLoader({Isloading:false})
        if(resp.status==true)
        {
            this.setState({
                verificationCode: resp.code,
                isExpired: false,
                UserId:resp.userId
            },()=>{
                $("#Form_1stStep").hide()
                $("#Form_2ndStep").show()
                this.startCounter()
            })       
        }
        else
        {
            this.props.ShowAlert({Type:0,Msg:resp.message })
            setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
        }
    },
    (error)=>{
        this.props.ShowLoader({Isloading:false})
        this.props.ShowAlert({Type:0,Msg:"Something went wronge, please try again."})
        setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50); 
    }
  )
  
}
startCounter=()=>{
    var timer2 = "1:01";
    var interval = setInterval(()=> {

        var timer = timer2.split(':');
        //by parsing integer, I avoid all extra string processing
        var minutes = parseInt(timer[0], 10);
        var seconds = parseInt(timer[1], 10);
        --seconds;
        minutes = (seconds < 0) ? --minutes : minutes;
        if (minutes < 0) clearInterval(interval);
        seconds = (seconds < 0) ? 59 : seconds;
        seconds = (seconds < 10) ? '0' + seconds : seconds;
        var counterlabel= minutes + ':' + seconds
        if(counterlabel=="0:00")
        {
            this.setState({
                isExpired:true,
                verificationCode:null,
            })
        }      
        //minutes = (minutes < 10) ?  minutes : minutes;
        $('.countdown').html(counterlabel);
        timer2 = counterlabel;
    }, 1000);
}
VerifyCode=(e)=>{
    e.preventDefault()

    if(this.state.isExpired)
    {
        this.props.ShowAlert({Type:0,Msg: "Verification code is expired, please resend the code"})
        setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
        return
    }
    if($("#RecoverPassword_VerficationCode").val() != this.state.verificationCode)
    {
        this.props.ShowAlert({Type:0,Msg: "Invalid Code"})
        setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
        return
    }
    $("#Form_2ndStep").hide()
    $("#Form_3rdStep").show()
}
ResetPassword=(e)=>{
    e.preventDefault()
    if($("#ResetPassword_Password").val() != $("#ResetPassword_ConfirmPassword").val())
    {
      this.props.ShowAlert({Type:0,Msg: "New password does not match with confirm password"})
      setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
      return
    }
    this.props.ShowLoader({Isloading:true})
    var Parameters={
      UserId: this.state.UserId,
      Newpassword: $("#ResetPassword_Password").val(),
    }
    Common.Ajax("","Get",false,Common.APILinks.ResetPassword,Parameters,(resp)=>{  
      this.props.ShowLoader({Isloading:false})
      if(resp.status==true)
      {
        this.props.ShowAlert({Type:1,Msg:"Password updated successfully" })
        setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
        this.props.history.push("/Login")
      }
      else
      {
        this.props.ShowAlert({Type:0,Msg:resp.message })
        setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
      }
    },
    (error)=>{
        this.props.ShowLoader({Isloading:false})
        this.props.ShowAlert({Type:0,Msg:"Something went wronge, please try again."})
        setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50); 
    }
    )
  
}

}

export default connect( mapStateToProps , mapDispatchToProps )(forgotpassword);